import { useEffect, useState } from "react";
import api, { formatErr } from "@/lib/api";
import { PageHeader, Section } from "@/components/Shared";
import { toast } from "sonner";

const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

export default function MyPayslips() {
  const [list, setList] = useState([]);
  useEffect(() => {
    api.get("/payslips/me").then((r) => setList(r.data)).catch((e) => toast.error(formatErr(e)));
  }, []);
  const dl = async (year, month) => {
    const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/payslips/me/${year}/${month}/pdf`, {
      credentials: "include",
    });
    if (!r.ok) return toast.error("Download failed");
    const blob = await r.blob();
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank"); URL.revokeObjectURL(url);
  };

  const dlForm16 = async (fy) => {
    const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/payroll/form16/me/${fy}/pdf`, {
      credentials: "include",
    });
    if (!r.ok) return toast.error("Form 16 not available");
    const blob = await r.blob();
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank"); URL.revokeObjectURL(url);
  };

  // Group payslips by FY (Apr-Mar) for Form 16 download
  const fyOf = (y, m) => m >= 4 ? `${y}-${String(y+1).slice(-2)}` : `${y-1}-${String(y).slice(-2)}`;
  const fys = Array.from(new Set(list.map(p => fyOf(p.year, p.month))));

  return (
    <div data-testid="my-payslips">
      <PageHeader overline="Compensation" title="My Salary Slips" subtitle="Download your monthly payslips." />

      {fys.length > 0 && (
        <div className="bg-white border border-[#E5E5E5] p-5 mb-4" data-testid="form16-block">
          <div className="flex items-start justify-between gap-4 flex-wrap">
            <div>
              <div className="eyebrow">Year-end summary</div>
              <h3 className="font-head text-xl font-semibold tracking-tight mt-1">Form 16 (TDS Preview)</h3>
              <p className="text-xs text-neutral-500 mt-1 max-w-md">A preview TDS certificate auto-generated from your payslips, exemption declarations and configured tax slabs. Not a legal substitute for the official Form 16.</p>
            </div>
            <div className="flex flex-wrap gap-2">
              {fys.map((fy) => (
                <button key={fy} onClick={() => dlForm16(fy)} data-testid={`form16-dl-${fy}`}
                  className="h-9 px-3 border border-[#1F4E8C] text-[#1F4E8C] hover:bg-[#1F4E8C] hover:text-white transition-colors text-xs font-semibold">
                  FY {fy} ↓
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      <Section title={`${list.length} available`}>
        <table className="w-full table-dense">
          <thead>
            <tr className="border-b-2 border-[#1F4E8C] text-left">
              <th className="eyebrow">Month</th><th className="eyebrow">Working Days</th><th className="eyebrow">OT</th>
              <th className="eyebrow">Gross</th><th className="eyebrow">Deductions</th><th className="eyebrow">Net</th><th />
            </tr>
          </thead>
          <tbody>
            {list.length === 0 && <tr><td colSpan={7} className="text-center py-8 text-neutral-500">No payslips yet. Your payslip will be available once your monthly payroll is finalised.</td></tr>}
            {list.map((p) => (
              <tr key={`${p.year}-${p.month}`} className="border-b border-[#F0F0EE]">
                <td className="font-medium">{months[p.month-1]} {p.year}</td>
                <td>{p.working_days}</td>
                <td>{p.overtime_hours}h</td>
                <td>₹{p.gross?.toLocaleString()}</td>
                <td>₹{p.total_deductions?.toLocaleString()}</td>
                <td className="font-head font-semibold text-[#FF5500]">₹{p.net?.toLocaleString()}</td>
                <td>
                  <button onClick={() => dl(p.year, p.month)} data-testid={`slip-dl-${p.year}-${p.month}`}
                    className="text-xs underline hover:text-[#1F4E8C]">Download ↓</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Section>
    </div>
  );
}
